import get from 'lodash/get';
import * as AuthHelper from '@Services/Auth/AuthHelper';

class Pendo {
  isDisabled = false;

  isLinked = false;

  isInitialized = false;

  link(url) {
    return new Promise((resolve, reject) => {
      const onLoad = () => {
        this.isLinked = true;
        resolve();
      };

      const onError = () => {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Pendo could not be loaded');
      };

      if (this.isLinked) {
        onLoad();
      } else if (!this.isDisabled && url) {
        /* eslint-disable */
        (function (p, e, n, d, o) {
          let w;
          let x;

          o = p[d] = p[d] || {};
          o._q = [];
          const v = ['initialize', 'identify', 'updateOptions', 'pageLoad'];

          for (w = 0, x = v.length; w < x; ++w)
            (function (m) {
              o[m] =
                o[m] ||
                function () {

                  o._q[m === v[0] ? 'unshift' : 'push']([m].concat([].slice.call(arguments, 0)));
                };
            })(v[w]);
          const y = e.createElement(n);
          y.async = !0;
          y.src = url;
          y.onload = onLoad;
          y.onerror = onError;
          const z = e.getElementsByTagName(n)[0];
          z.parentNode.insertBefore(y, z);
        })(window, document, 'script', 'pendo');
        /* eslint-enable */
      } else {
        // eslint-disable-next-line prefer-promise-reject-errors
        reject('Pendo is disabled or not configured');
      }
    });
  }

  updateVisitor(user) {
    if (window.pendo && !this.isDisabled) {
      const initObj = {
        visitor: {},
        events: {
          guidesLoaded() {
            get(window, 'pendo.BuildingBlocks.BuildingBlockResourceCenter.getResourceCenter', () => {})();
          },
        },
      };

      const accountId = get(user, 'details.loginDetails.accountId', 'ae:unknown');
      const accountName = get(user, 'details.loginDetails.accountName', 'Unknown Account name');
      const license = get(user, 'details.license', 'ae:unknown');
      const organizationType = get(user, 'details.organizationType', 'ae:unknown');
      let IsAnonymous = AuthHelper.isAnonymousUser();
      if (AuthHelper.isUpgradedFromAnonymous()) {
        IsAnonymous = false;
      }

      Object.assign(initObj, {
        account: {
          id: accountId,
          name: accountName,
          organizationType,
          license,
        },
      });

      Object.assign(initObj.visitor, { IsAnonymous, organizationType, license });

      Object.assign(initObj.visitor, {
        id: get(user, 'details.loginDetails.userId', 'ae:unknown'),
      });

      const adobeVisitorId = get(window, 'pageDataTracker.getVisitorId', () => {})();

      if (IsAnonymous && adobeVisitorId) {
        Object.assign(initObj.visitor, {
          id: `mi:${adobeVisitorId}`,
        });
      }

      const initializePendo = () => {
        window.pendo.initialize(initObj);
        this.isInitialized = true;
      };

      if (!this.isInitialized) {
        if (window.requestIdleCallback) {
          window.requestIdleCallback(initializePendo);
        } else {
          setTimeout(initializePendo, 0);
        }
      } else {
        window.pendo.updateOptions(initObj);
      }
    }
  }

  setNoTracking(noTracking) {
    this.isDisabled = noTracking;
  }

  disablePendo() {
    // only call one time after login if Pendo was enabled before
    if (!this.isDisabled && window.pendo) {
      // stop tracking
      const stopPendoTrackingResult = window.pendo.stopSendingEvents();
      // stop loading new guides
      window.pendo.stopGuides();

      Logger.info('Disabling Pendo: ', stopPendoTrackingResult);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  closeResourceCenter = (e) => {
    try {
      const target = e && (e.target || e.srcElement);
      if (
        window.pendo &&
        window.pendo.dom &&
        !window.pendo.dom(target).closest('#pendo-guide-container').length &&
        !window.pendo.dom(target).closest('.rx-btn-help').length &&
        window.pendo.getActiveGuide()
      ) {
        window.pendo?.BuildingBlocks?.BuildingBlockResourceCenter?.dismissResourceCenter();
      }
    } catch (error) {
      Logger.error(error);
    }
  };
}

export default new Pendo();
